<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="apps">
    <ItemCommonDescription
      :data-card="dataCard.data[0]"
      :datastory-link="datastoryLink"
      :data-values="dataCard.value[0]"
      @reload-data-card="reloadDataCard"
    />
    <ItemViews :views="dataCard.data[0].popularity" />
    <ItemsRelated :card-id="dataCard.data[0].id" />
  </div>
</template>

<script>
import ItemCommonDescription from './ItemCommonDescription.vue'
import ItemViews from './ItemViews'
import ItemsRelated from './ItemsRelated'
/**
 * App view disposition
 * @example [none]
 */
export default {
  name: 'AppItem',
  components: { ItemCommonDescription, ItemViews, ItemsRelated },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
  },
  computed: {
    datastoryLink() {
      return this.dataCard.value && this.dataCard.value[0].url
    },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
  },
}
</script>

<style lang="stylus" scoped>
.apps
  display: flex
  flex-direction: column
  width: 100%
  gap: vw(10px)
</style>
